import Config from "../_config/config";
import myAxios from "./axiositeachWrapper";

const BASE = `${Config.nodeSiteUrl}v1/mailbox`;

export interface MailboxConnection {
  id: number;
  provider: "gmail" | "outlook" | string;
  accountEmail: string;
  status: "active" | "paused" | "error" | "revoked" | string;
  lastSyncedAt: string | null;
  lastError: string | null;
}

export interface MailboxOauthPublicConfig {
  google: { clientId: string | null; redirectUri: string | null; configured: boolean };
  microsoft: {
    clientId: string | null;
    redirectUri: string | null;
    tenantAuthority: string | null;
    configured: boolean;
  };
  iteachBaseUrl: string | null;
  source: "database" | "env" | "none";
}

export interface MailboxOauthConfigInput {
  google?: { clientId?: string; clientSecret?: string; redirectUri?: string };
  microsoft?: {
    clientId?: string;
    clientSecret?: string;
    redirectUri?: string;
    tenantAuthority?: string;
  };
  iteachBaseUrl?: string;
}

// NOTE: myAxios is a plain-JS wrapper, so the generic on `.get<T>/.put<T>` is
// mis-bound to the request body, not the response. The codebase convention is
// to type calls as `<any>` and let the caller shape the response (see
// CampaignService.ts).
class MailboxService {
  list() {
    return myAxios.get<any>(`${BASE}/connections`);
  }

  disconnect(id: number) {
    return myAxios.delete<any>(`${BASE}/connections/${id}`);
  }

  triggerSync(id: number) {
    return myAxios.post<any>(`${BASE}/connections/${id}/sync`);
  }

  initGoogle() {
    return myAxios.post<any>(`${BASE}/oauth/google/init`);
  }

  initOutlook() {
    return myAxios.post<any>(`${BASE}/oauth/microsoft/init`);
  }

  getOauthConfig() {
    return myAxios.get<any>(`${BASE}/admin/oauth-config`);
  }

  saveOauthConfig(input: MailboxOauthConfigInput) {
    return myAxios.put<any>(`${BASE}/admin/oauth-config`, input);
  }
}

export default new MailboxService();
